import { render, staticRenderFns } from "./doItActionBox.vue?vue&type=template&id=d8d9addc"
import script from "./doItActionBox.vue?vue&type=script&lang=js"
export * from "./doItActionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports